import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import MainLayout from "layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { fetchProjects } from "store/slices/exploreSlice";
import ProjectPost from "components/Project/ProjectPost";

const Explore = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("nav");
  const token = useAppSelector((state) => state.user.auth.access_token);
  const posts = useAppSelector((state) => state.explore.posts);

  useEffect(() => {
    if (token) {
      dispatch(fetchProjects());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <MainLayout heading={t("explore")}>
      {posts &&
        posts.map((project, index) => (
          <ProjectPost key={index} project={project} />
        ))}
    </MainLayout>
  );
};

export default Explore;
